import { isGlowPlatformAdmin } from '../../../../assets/utils/comm/platformAdminUtils';

/**
 * GLOW 소식 공지팝업 — localStorage dismiss 키 및 form_data 파싱 유틸
 */

export const NOTICE_POPUP_DISMISS_PREFIX = 'glow:noticePopupDismiss';

export function getNoticePopupDismissKey(bbsTpCd, bbscttUid) {
  return `${NOTICE_POPUP_DISMISS_PREFIX}:${bbsTpCd}:${bbscttUid}`;
}

export function getTodayDateString() {
  return new Date().toISOString().slice(0, 10);
}

export function isNoticePopupDismissedToday(bbsTpCd, bbscttUid) {
  try {
    const key = getNoticePopupDismissKey(bbsTpCd, bbscttUid);
    return localStorage.getItem(key) === getTodayDateString();
  } catch {
    return false;
  }
}

export function dismissNoticePopupForToday(bbsTpCd, bbscttUid) {
  try {
    const key = getNoticePopupDismissKey(bbsTpCd, bbscttUid);
    localStorage.setItem(key, getTodayDateString());
  } catch {
    // ignore quota / private mode
  }
}

export function parseBbscttFormData(raw) {
  if (!raw) return {};
  try {
    const value = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return value && typeof value === 'object' ? value : {};
  } catch {
    return {};
  }
}

/** 목록/상세 DTO에서 공지팝업 활성 여부 */
export function isArticlePopupNoticeOn(item) {
  if (!item) return false;
  const raw = item.bbscttFormData ?? item.bbsctt_form_data;
  return parseBbscttFormData(raw).popupNoticeYn === 'Y';
}

/** GLOW 플랫폼 관리자(ADMIN · SYSTEM) — 목록·팝업 관리 표시 등 */
export function canViewNoticePopupListAdminInfo(user) {
  return isGlowPlatformAdmin(user);
}

export { isGlowPlatformAdmin };

export function countPopupNoticeArticles(items) {
  if (!Array.isArray(items)) return 0;
  return items.reduce((acc, item) => acc + (isArticlePopupNoticeOn(item) ? 1 : 0), 0);
}

export function buildBbscttFormDataWithPopup(raw, popupNoticeOn) {
  const base = parseBbscttFormData(raw);
  return JSON.stringify({
    ...base,
    popupNoticeYn: popupNoticeOn ? 'Y' : 'N',
  });
}

export function isNoticePopupWindowPath(pathname = '') {
  return String(pathname).includes('/support/glow-news/notice-popup/');
}

export function openNoticePopupWindow(bbscttUid, bbsTpCd) {
  const url = `/support/glow-news/notice-popup/${bbscttUid}`;
  const width = 800;
  const height = 640;
  const left = Math.round((window.screen.availWidth - width) / 2 + (window.screen.availLeft || 0));
  const top = Math.round((window.screen.availHeight - height) / 2 + (window.screen.availTop || 0));
  const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;
  const name = `glow_notice_popup_${bbsTpCd || 'news'}_${bbscttUid}`;
  const win = window.open(url, name, features);
  if (win) win.focus();
  return win;
}
